// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"156":"aea4b713","324":"80fd3eed","388":"1dbbfcf8","591":"6bfa4a58","682":"fbdcee04","825":"1ab89766","828":"9592404d","962":"85b00977"}[chunkId] + ".chunk.js";
};